module.exports = __webpack_public_path__ + "img/img1.a694d7b4.jpg";